// ** React Imports
import { useCallback, useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import SelectedElement from "components/other/SelectedElement";
import Block from "components/layout/Block";

// ** Users Components
import ChangeFiltersButton from "containers/Users/components/ChangeFiltersButton";

// ** Hooks
import useNearbyLocationFilterData from "../hooks/useNearbyLocationFilterData";
import useNearbySexFilterData from "../hooks/useNearbySexFilterData";

// #####################################################

export const NearbyResultsDescription = ({
	filtersOpen,
	setFiltersOpen,
	cityName,
	regionName,
	countryCode,
}) => {
	const locationFilterData = useNearbyLocationFilterData({
		cityName,
		regionName,
		countryCode,
	});
	const sexFilterData = useNearbySexFilterData();

	const language = useSelector((state) => state.globalCommon.language);

	// ** Filtry - Lista
	const filters = useMemo(() => {
		const filtersArray = [sexFilterData, locationFilterData];
		return filtersArray.filter((x) => Boolean(x));
	}, [sexFilterData?.selected, locationFilterData?.selected, language]);

	const renderSelectedFilters = useCallback(() => {
		return filters.map((filter, index) => (
			<SelectedElement
				key={filter?.label || index}
				data={filter}
				isLastFilter={filters.length === index + 1}
				labelToLowerCase={false}
			/>
		));
	}, [filters]);

	// #####################################################

	return (
		<Block flex alignCenter>
			<Block>
				{renderSelectedFilters()}
				<ChangeFiltersButton
					filtersOpen={filtersOpen}
					setFiltersOpen={setFiltersOpen}
				/>
			</Block>
		</Block>
	);
};

// #####################################################
